export default function authHeader() {
    const token = localStorage.getItem("access_token");
    const phone_number = JSON.parse(localStorage.getItem("phone_number"));

    if (token && phone_number) {
        return { "phone-number": phone_number, "token": token };
    } else {
        return {};
    }
}